export function applyAffiliationRouteQuery(state, query = {}, now) {
  // Deep-link hidrata apenas datas; status/products fora de escopo (VSUS-1324).
  // fetchToMe lê filters_tome (objeto do modal), não query string.
  state.dateRange.startDate = query.start_date || now;
  state.dateRange.endDate = query.end_date || now;
}
